import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import TextInput from '../../../components/lib/TextInput';

import { Button } from 'hosman-material';
import { S_EyeSlash, S_Eye } from 'hosman-material';

const LoginForm = ({ formValues, setFormValues, setLogin, submitForm, formErrors, setFormErrors, isSubmitting }) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleSetLogin = () => {
    setFormErrors({})
    setLogin(false)
  }

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (!isSubmitting) submitForm();
      }}
      className='flex flex-col gap-3 py-3 w-full'
    >
      <p className='font-semibold mb-3'>Débloquez toute la donnée en vous connectant</p>

      <div className='flex flex-col gap-1'>
        <TextInput 
          name='email' 
          type='email' 
          label='E-mail' 
          value={formValues.email} 
          onChange={(e) => setFormValues({ ...formValues, email: e.target.value })}
        />

        {formErrors.email && <p className='text-sm text-ih-red'>{formErrors.email[0]}</p>}
      </div>

      <div className='flex flex-col gap-1'>
        <div className='relative'>
          <TextInput
            name='password' 
            type={showPassword ? 'text' : 'password'}
            label='Mot de passe' 
            value={formValues.password} 
            onChange={(e) => setFormValues({ ...formValues, password: e.target.value })}
          />

          <FontAwesomeIcon icon={showPassword ? S_EyeSlash : S_Eye} className='text-white/80 absolute top-12 right-2 cursor-pointer' onClick={() => setShowPassword((prev) => !prev)} />
        </div>

        {formErrors.password && <p className='text-sm text-ih-red'>{formErrors.password[0]}</p>}
      </div>

      <p className='text-white hover:text-white/60 text-sm underline cursor-pointer transition-all w-max my-5' onClick={() => handleSetLogin()}>Pas encore de compte?</p>

      <Button
        buttonType='submit'
        label='Connexion'
        onClick={() => submitForm()}
        isLoading={isSubmitting}
      />
    </form>

  )
}

export default LoginForm;
